/**
 * The Microwave Window - PDF Presentation Configuration
 *
 * Slide-by-slide configuration with:
 * - Page numbers
 * - Pre-scripted narrations for avatar TTS
 */

export const microwaveWindowPresentation = {
  pdfUrl: 'https://storage.googleapis.com/qudemo-test-qudemo/microwave.pdf',

  slides: [
    {
      page: 1,
      title: 'The Microwave Window',
      narration: `Microwaves occupy the electromagnetic spectrum between 300 MHz and 300 GHz. Because their wavelengths are relatively short,   centimeters to millimeters,   they behave more like light than traditional radio waves—traveling in straight lines,   Line-of-Sight.`,
    },
  ],
};

export default microwaveWindowPresentation;
